import {Popover} from "@material-ui/core";
import React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "../Button/Button";
import classes from "./Popup.module.css";
import {translation} from "../../../I18n/i18n";
import SpellChecker from "../SpellChecker/SpellChecker";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

const Element = (props) => {
const ifIsNotDownloadButtonContainer=()=>{
    return (
        props.oneButton ?
            <Grid container>
                <Grid item xs={ 4 } style={ {padding: '0 2px 0 0'} }>
                    <Button
                        label={ props.cancelBtnLabel ? props.cancelBtnLabel : "Close" }
                        variant={ props.cancelBtnVariant ? props.cancelBtnVariant : "danger" }
                        actionHandler={ props.onClose }
                        size="sm"
                        isVisible={ true }
                        lang={ props.lang }
                    />
                </Grid>
            </Grid>
            : <Grid container>
                <Grid item xs={ 3 } style={ {padding: '0 2px 0 0'} }>
                    <Button
                        label={ props.submitBtnLabel ? props.submitBtnLabel : "Yes" }
                        variant="success"
                        actionHandler={ props.onSubmit }
                        size="sm"
                        isVisible={ true }
                        lang={ props.lang }
                    />
                </Grid>
                <Grid item xs={ 3 } style={ {padding: '0 0 0 2px'} }>
                    <Button
                        isVisible={ true }
                        label={ props.cancelBtnLabel ? props.cancelBtnLabel : "No" }
                        variant={ props.cancelBtnVariant ? props.cancelBtnVariant : "danger" }
                        actionHandler={ props.onClose }
                        size="sm"
                        lang={ props.lang }
                    />
                </Grid>
                <Grid item xs={ 6 }/>
            </Grid>
    )
}
    return (
        <Popover id={ props.id }
                 open={ props.show }
                 onClose={ props.onClose }
                 anchorEl={ props.anchorEl }
                 anchorOrigin={ {
                     vertical: 'bottom',
                     horizontal: 'center',
                 } }
                 transformOrigin={ {
                     vertical: 'top',
                     horizontal: 'center',
                 } }>
            <div className={ classes.popup }>
                { props.title ?
                    <Grid container>
                        <Grid item xs={ 11 }>
                            <h1 className={ classes.popupTitle }>{ props.lang ? translation (props.lang, props.title) : props.title }</h1>
                        </Grid>
                        {props.downloadButton?
                        <Grid item xs={ 1 } >
                            <HighlightOffIcon className={classes.closePopupIcon} onClick={props.onClose}></HighlightOffIcon>
                        </Grid>:null}
                    </Grid>:null}

                { props.subtitle ? <p className={ classes.popupSubtitle }> { props.subtitle } </p> : null }
                { props.body ?
                    <p className={ classes.popupBody }>{ props.lang ? htmlNewLine(translation(props.lang, props.body).split("\n")) : htmlNewLine(props.body.split("\n")) }</p> :
                    <br/> }
                { props.hasInput ?
                    <div className={ classes.popupInput }>
                        <SpellChecker freeTextBox
                                      toolbar
                                      dict={ props.dict }
                                      lang={ props.lang }
                                      placeholder={`${ translation(props.lang, "Message")} ...`}
                                      value={ props.inputValue }
                                      onChange={ props.onInputValueChange }
                        />
                    </div>
                    : null }
                <div>
                    {props.downloadButton? (
                            <Grid container>
                                <Grid item xs={ 3 } style={ {padding: '0 2px 0 0'} }>
                                    <Button
                                        label={ props.DocxBtnLabel }
                                        variant="primary"
                                        actionHandler={ props.downloadDocxFile }
                                        size="sm"
                                        isVisible={ true }
                                        lang={ props.lang }
                                    />
                                </Grid>
                                <Grid item xs={ 3 } style={ {padding: '0 0 0 2px'} }>
                                    <Button
                                        label={ props.PdfBtnLabel }
                                        variant="primary"
                                        actionHandler={ props.downloadPdfFile }
                                        size="sm"
                                        isVisible={ true }
                                        lang={ props.lang }
                                    />
                                </Grid>
                                <Grid item xs={ 6 }/>
                            </Grid>
                        ) : ifIsNotDownloadButtonContainer()
                    }
                </div>
            </div>
        </Popover>
    );

}

export default Element;

let htmlNewLine = (texts) => {
    return texts.map(part => <span key={part}>{ solidifyQuotation(part.split(`"`)) }<br/></span>)
}

let solidifyQuotation = (texts) => {
    return texts.map((part, i) => i % 2 === 0 ? <span key={i}>{ part }</span> : <strong key={i}>{ part }</strong>)
}